import Spinner from '@components/common/spinner'

const Polling = () => (
  <div className="flex flex-col items-center justify-center h-40 space-y-5">
    <h2 className="text-xl text-center font-600">
      Please wait while we are rescheduling your class...
    </h2>
    <Spinner classes="h-10 w-10 text-orange" />
  </div>
)

export default Polling
